import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 24px;
  width: 24px;
`

export const UsersIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_948_15318)">
        <path d="M19.2004 17H11.4004V15C11.4004 15 12.1004 13.4 15.2004 13.4C18.3004 13.4 19.1004 15 19.1004 15V17H19.2004Z" />
        <path d="M11.6004 12.8C11.0004 12.7 10.4004 12.6 9.60039 12.6C5.80039 12.6 4.90039 14.6 4.90039 14.6V17.1H10.1004V14.6C10.0004 14.6 10.3004 13.5 11.6004 12.8Z" />
        <path d="M15.2004 11.9C16.1945 11.9 17.0004 11.0941 17.0004 10.1C17.0004 9.10591 16.1945 8.30002 15.2004 8.30002C14.2063 8.30002 13.4004 9.10591 13.4004 10.1C13.4004 11.0941 14.2063 11.9 15.2004 11.9Z" />
        <path d="M9.79961 11.3C11.0146 11.3 11.9996 10.3151 11.9996 9.10002C11.9996 7.885 11.0146 6.90002 9.79961 6.90002C8.58458 6.90002 7.59961 7.885 7.59961 9.10002C7.59961 10.3151 8.58458 11.3 9.79961 11.3Z" />
      </g>
      <defs>
        <clipPath id="clip0_948_15318">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  )
}
